import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_user"
}
const _hoisted_3 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_new_box_item_info"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_NewBoxItemInfoModal = _resolveComponent("NewBoxItemInfoModal")!
  const _component_UserModal = _resolveComponent("UserModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.gift_record,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "用户",
            prop: "user_id"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.user.id ? _ctx.user.nickname + '-' + _ctx.user.mobile : '选择用户'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "赠送类型",
            prop: "gift_type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.gift_record.gift_type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.gift_record.gift_type) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gift_types, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.key,
                      value: item.value,
                      key: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.gift_record.gift_type == 'product')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "商品",
                prop: "product_id"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.product.id ? _ctx.product.name + '-' + _ctx.formatPrice(_ctx.product.recycle_price) : '选择商品'), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "单价",
                prop: "price"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.gift_record.balance,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gift_record.balance) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _createVNode(_component_NewBoxItemInfoModal, { add_box_item_infos: _ctx.add_box_item_infos }, null, 8, ["add_box_item_infos"]),
    _createVNode(_component_UserModal, { add_users: _ctx.add_users }, null, 8, ["add_users"])
  ], 64))
}